import { Box, Typography, Chip, Stack } from '../../../imports/muiImport';
import RedeemableProduct from '../redeemableProducts/RedeemableProduct';
import ProductDetailPara from './ProductDetailPara';
import { useSelector } from 'react-redux';
import MarkdownRenderer from './MarkdownRenderer';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { RedeemTypeChip } from '../../../pages/PRODUCTDETAILS/productUtils/ProductDetailCard';

const normalizeContent = (input) => {
    if (!input) return '';
    return input
        .replace(/<br\s*\/?>/gi, '\n') // Convert <br> to \n
        .replace(/\r\n|\r|\n/g, '\n'); // Normalize all newlines
};

function MobileProductDetails() {
    const PRODUCTDETAILS = useSelector((state) => state.ProductDetail?.allData);
    return (
        <Box
            mt={3}
            sx={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                alignItems: 'center',
                maxWidth: '100%',
            }}
        >
            <Typography
                variant="h1"
                sx={{
                    color: 'text.primary',
                    fontSize: { xs: '4.5vw', sm: '2.5vw' },
                    fontWeight: 500,
                    textAlign: 'center',
                    overflowWrap: 'break-word',
                    wordBreak: 'break-word',
                    mb: 2,
                    px: 2,
                }}
            >
                {PRODUCTDETAILS?.name}
            </Typography>

            <Chip
                label={`${PRODUCTDETAILS?.discount}% ${PRODUCTDETAILS?.productType}`}
                sx={{
                    px: '4px',
                    backgroundColor: 'primary.main',
                    color: 'white.main',
                    fontSize: {
                        xs: '3.8vw',
                        sm: '2vw',
                    },
                    boxShadow: 6,
                    mb: 1,
                }}
            />

            <Box
                sx={{
                    py: 2,
                    borderRadius: 3,
                    display: 'flex',
                    justifyContent: 'flex-start',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Typography
                    variant="body1"
                    sx={{
                        mb: 1,
                        color: 'text.primary',
                        fontSize: {
                            xs: '4.1vw',
                            sm: '2vw',
                        },
                        fontWeight: 500,
                        textTransform: 'capitalize',
                    }}
                >
                    Redeemable at:
                </Typography>
                <RedeemTypeChip type={PRODUCTDETAILS?.usageLocation} />

                <Typography
                    variant="h2"
                    sx={{
                        mt: 2,
                        color: 'textPrimary.main',
                        fontSize: {
                            xs: '3.1vw',
                            sm: '2vw',
                        },
                    }}
                >
                    *Terms & Condtions apply
                </Typography>
            </Box>

            <ProductDetailPara productDescription={normalizeContent(PRODUCTDETAILS?.description)} />

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    rowGap: 3,
                    maxWidth: '100%',
                }}
            >
                {PRODUCTDETAILS?.redemptionInfo?.length > 0 && (
                    <Stack direction="column" sx={{ borderBottom: 1, borderColor: 'borderColor.main' }}>
                        <Typography
                            variant="h2"
                            sx={{
                                color: 'primary.main',
                                fontSize: '1.225rem',
                                textAlign: 'left',
                                fontWeight: 500,
                            }}
                        >
                            How to Redeem
                        </Typography>

                        <MarkdownRenderer content={PRODUCTDETAILS?.redemptionInfo} />
                    </Stack>
                )}

                {PRODUCTDETAILS?.tnc?.length > 0 && (
                    <Stack direction="column" sx={{ borderBottom: 1, borderColor: 'borderColor.main' }}>
                        <Typography
                            variant="h2"
                            sx={{
                                color: 'primary.main',
                                fontSize: '1.225rem',
                                textAlign: 'left',
                                fontWeight: 500,
                            }}
                        >
                            Terms & Condtions
                        </Typography>
                        <MarkdownRenderer content={PRODUCTDETAILS?.tnc} />
                    </Stack>
                )}
            </Box>
        </Box>
    );
}

export default MobileProductDetails;
